<template>
    <div class="card">
        <div class="row">
            <div class="col-12">
                <Multiselect
                    v-model="getLocation"
                    :options="locationList"
                    mode="single"
                    :can-clear=true
                    :searchable="true"
                    :placeholder="this.$t('inventory_search_location') + ' (' + this.locationList.length + ')'"
                    @select="itemSelected(1)"
                    @clear="itemSelected(0)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";

export default {
    name: "LocationSearchBox",
    components: {
        Multiselect
    },
    data(){
        return{
            getLocation: '',
            locationList: [],
            locationDetailList: '',
        }
    },
    methods: {
        updateMode(getLocID){
            this.getLocation = getLocID
            // activate as user clicked
            this.itemSelected(1)
        },
        async getBackEndData(){
            await this.$mainApi.get('api/other-details/location/')
                .then(response => {
                    if(response.data.status === 80){
                        let data = response.data.details
                        this.locationDetailList = response.data.details
                        for(let i=0;i<data.length;i++){
                            this.locationList.push({
                                "label": data[i]['label'],
                                "value": data[i]['id'],
                            })
                        }
                    }
                })
        },
        itemSelected(flag){
            // 0 -> Clear, 1 -> selected
            if(flag === 0){
                this.getLocation = null
            }
            this.$emit('loc', this.getLocation === null ? null : this.locationDetailList.filter(a => a.id === this.getLocation)[0])
        }
    },
    mounted() {
        this.getBackEndData()
    }
}
</script>

<style scoped>

</style>
